import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';
import { DataUtility } from '../../../../../../../utilities/DataUtility';
import { EquifaxDetailCardComponent } from '../equifax-detail-card/equifax-detail-card.component';

@Component({
  selector: 'app-guest-email-result-card',
  templateUrl: './guest-email-result-card.component.html',
  styleUrls: ['./guest-email-result-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    EquifaxDetailCardComponent
  ]
})
export class GuestEmailResultCardComponent implements OnInit {

  @Input() guest!: any;

  data: DetailPair[] = [];
  title = 'Email Trust';
  trustDecision!: string;

  emailAffiliationReason!: string;
  emailVerificationReason!: string;
  emailInsightsReason!: string;

  constructor(private dataUtility: DataUtility) { }

  ngOnInit() {
    this.emailAffiliationReason = this.dataUtility.getCheckReason(this.guest, 'emailAffiliationReason');
    this.emailVerificationReason = this.dataUtility.getCheckReason(this.guest, 'emailVerificationReason');
    this.emailInsightsReason = this.dataUtility.getCheckReason(this.guest, 'emailInsightsReason');

    this.populateEmailTrustInfo();
  }

  populateEmailTrustInfo() {
    this.trustDecision = this.dataUtility.getTrustInfo(this.guest, 'emailTrust');

    this.data.push(new DetailPair("Affiliation", this.dataUtility.getTrustInfo(this.guest, 'emailAffiliation') ? this.dataUtility.getTrustInfo(this.guest, 'emailAffiliation') : null, this.emailAffiliationReason));
    this.data.push(new DetailPair("Verification", this.dataUtility.getTrustInfo(this.guest, 'emailVerification') ? this.dataUtility.getTrustInfo(this.guest, 'emailVerification') : null, this.emailVerificationReason));
    this.data.push(new DetailPair("Insights", this.dataUtility.getTrustInfo(this.guest, 'emailInsights') ? this.dataUtility.getTrustInfo(this.guest, 'emailInsights') : null, this.emailInsightsReason));
  }

}